<template>
  <div class="goods_add">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="用户名" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input v-model="ruleForm.password" type="password"></el-input>
      </el-form-item>
        <el-form-item label="设置">

            <el-button @click="set_current_id"> 暂无上级 </el-button>
        </el-form-item>
      <el-form-item label="用户搜索">
        <span>
          <el-autocomplete
            v-model="state_user"
            :fetch-suggestions="querySearchAsync"
            placeholder="用户搜索"
            @select="handleSelect"
          ></el-autocomplete
        ></span>
      </el-form-item>

      <el-form-item label="当前上级">
        <span v-if="current_id == 0"> 暂无上级 </span>
        <span v-else> {{ this.current_user }}{{ this.level }}</span>
      </el-form-item>
      <el-form-item label="等级" prop="level">
        <el-select v-model="ruleForm.level" placeholder="请选择等级">
          <el-option
            :label="item"
            :value="item"
            v-for="(item, index) in result.data"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否启用" prop="status">
        <el-select v-model="ruleForm.status" placeholder="请选择">
          <el-option label="启用" value="1"></el-option>
          <el-option label="禁用" value="0"></el-option>
        </el-select>
      </el-form-item>



      <div>
        <!--
        <el-row>
          <el-col :span="3"> 头像</el-col>
          <el-col :span="5">
            <el-upload class="avatar-uploader" name="file" action="http://127.0.0.1:5000/admin/upload/index" list-type="picture-card" :on-success="goodsSuccess" :on-remove="handleShowRemove" :data="{ key: 'uploads' }" :before-upload="beforeAvatarUpload" ref="pic_show">
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-col>
        </el-row>
        -->
      </div>

      <el-form-item class="quill-editor-top">
        <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
        <el-button @click="resetForm('ruleForm')" ref="ruleForm">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      goods_show_pic: [],
      level: "",
      current_user: "",
      current_id: 0,
      state_user: "",
      restaurants: [],
      ruleForm: {
        name: "",
        password: "",
        level: "",
        status: "1",
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur",
          },
          {
            min: 5,
            max: 100,
            message: "长度在 5 到 50 个字符",
            trigger: "blur",
          },
        ],

        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],

        level: [
          {
            required: true,
            message: "请选择等级",
            trigger: "change",
          },
        ],
        status: [
          {
            required: true,
            message: "请选择状态",
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      result: (state) => state.agentuser.result,
      search_agent_user: (state) => state.search_agent_user.result,
    }),
  },
  methods: {
    ...mapActions({
      agentUserAddAction: "agentUserAddAction",
      AgentUserSearchAction: "AgentUserSearchAction",
    }),
      set_current_id(){
          this.current_id =0
      },
    querySearchAsync(queryString, cb) {
      this.AgentUserSearchAction({ username: queryString, type: "post" });
      this.current_id = 0;
      // this.restaurants = this.agent_user.options;

      var results = queryString
        ? this.restaurants.filter(this.createStateFilter(queryString))
        : this.restaurants;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 200 * Math.random());
    },
    createStateFilter(queryString) {
      return (state) => {
        return state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleSelect(item) {
      this.level = item.level;
      this.current_user = item.value;
      this.current_id = item.id;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        this.$message.error("上传头像图片只能是 JPG,PNG 格式!");
      }

      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }

      return (isPNG || isJPG) && isLt2M;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveData();
        } else {
          this.$message("请输入正确信息");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    saveData() {
      this.agentUserAddAction({
        type: "post",
        name: this.ruleForm.name,
        password: this.ruleForm.password,
        level: this.ruleForm.level,
        status: this.ruleForm.status,
        pid: this.current_id,
      });
    },
  },
  created() {
    this.agentUserAddAction({ type: "get" });
  },
  watch: {
    search_agent_user(newdata, olddata) {
      if (newdata.options.length == 0) {
        this.current_user = "";
      } else {
        this.restaurants = newdata.options;
      }
      console.log("tag", newdata, olddata);
    },
    result(newdata) {
      if (newdata.code == 401) {
        this.$message.error("用户已经存在");
      }
      if (newdata.code == 301) {
        this.$message({
          message: "恭喜你，用户添加成功",
          type: "success",
        });
        // this.ruleForm.name = "";
        // this.ruleForm.password = "";
        // this.current_id = 0;
        // this.agentUserAddAction({ type: "get" });

        this.$router.push({
          name: "agent_user_index",
        });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style>
.quill-editor {
  height: 400px;
}

.quill-editor-bottom {
  margin-bottom: 20px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #260a0a;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}

.avatar {
  width: 80px;
  height: 80px;
  display: block;
}

.el-upload--picture-card {
  width: 80px !important;
  height: 80px !important;
  line-height: 90px !important;
}

.el-upload-list--picture-card .el-upload-list__item {
  width: 80px !important;
  height: 80px !important;
  line-height: 90px !important;
}

.title_bg {
  background-color: #f5fffa;
  padding: 10px;
}

.el-form-item__content {
  margin-left: 30px;
}
</style>
